import { createMuiTheme } from '@material-ui/core/styles';

import red from '@material-ui/core/colors/red';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#000000',
            contrastText: '#FFF',
        },
        secondary: {
            main: '#f76c2f',
        },
        error: red,
    },
    typography: {
        useNextVariants: true,
    },
});

export default theme;
